/** 
 * 自定义打印封装
 */
export default function(caption, ...params) {
    const endCaption = '打印完毕==@@';
    if (caption == 'func') {
        return {
            success: (caption, ...params) => {
                console.log('%c%s', 'color:#00AE00', `@@=====${caption}-success=====`, ...params, endCaption);
            },
            fail: (caption, ...params) => {
                console.log('%c%s', 'color:#FF0000', `@@=====${caption}-fail=====`, ...params, endCaption);
            }
        }
    } else {
        if (arguments.length === 1) { // 直接打印值
            console.log('%c%s', 'color:#009B9B', '@@=====默认打印=====', arguments[0], endCaption)
        } else {
            console.log('%c%s', 'color:#6868FF', `@@=====${caption}=====:`, ...params, endCaption)
        }
    }
}

/**  
 * 调用示例：
 * this.log("func").success("某某某接口", currentRoute);
 * this.log("func").fail("某某某接口失败", "22222");
 * this.log("33333");
 * this.log("普通打印", "44444");
 */


/** 
 * 这两个方法可以用在请求拦截中
 * console.groupCollapsed();
 * console.groupEnd();
 */


// WEBPACK FOOTER //
// ./src/mixins/methods/log.js